import useSWR from 'swr';
import { CatalogItemOut, CatalogService } from '../../api';

const fetcher = async (): Promise<CatalogItemOut[]> => CatalogService.getCatalogItems(1, 500);

// The whole active catalog in one call (per_page 500 covers the largest account), so the picker
// can search and filter locally instead of hitting the API on every keystroke. The endpoint
// excludes archived items unless asked, which is what the picker wants: it must never offer one,
// and the add endpoint rejects them anyway.
export const useCatalogItems = () => {
  const { data, error, isLoading, mutate } = useSWR({ opId: 'getCatalogItems', scope: 'picker' }, fetcher);
  return { items: data ?? [], isLoading, isError: error, mutate };
};
